import { useSnapshot } from 'valtio'
import { state } from '../../../context/store'
import { Button, Heading, Row, Column, Link } from '../../Blocks';
import { closePopups } from '../../../utilities';


const ModalResetCustomisation = ({ id }) => {

    const snap = useSnapshot(state.current)

    const initialClose = (e) => {
        e.stopPropagation()
        state.current.status.confirmLeave = true
    }


    return (

        <Column id={id}>
            <Heading>
                Return to home page?
            </Heading>

            <Row justify="center" gap="12px">

                {snap.status.confirmLeave === true ? <Link link="/"><Button accent>Confirm Leave?</Button></Link> : <Button handleClick={(e) => initialClose(e)}>Exit Builder?</Button>}
                <Button handleClick={(e) => closePopups(e)}>Go Back</Button>

            </Row>
        </Column>
    )
}

export default ModalResetCustomisation
